"use client";

import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    }
  }, []);
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const partners = [{
    name: "Bureau Veritas",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_8.png?v=n5r7u0lp80a"
  }, {
    name: "Intertek",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_5.png?v=8z1dh4zx1um"
  }, {
    name: "SGS",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_6.png?v=i5uiyz3tmgf"
  }, {
    name: "TUV Rheinland",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_1.png?v=i2pmjdq1o2a"
  }, {
    name: "CCC Certification",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_2.png?v=e6sjzaryagv"
  }, {
    name: "G-Mark Certification",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_3.png?v=jurtvnuplk"
  }, {
    name: "ISO 9001",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_9.png?v=lrtfa14vbv"
  }, {
    name: "ICTI Ethical",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_7.png?v=n6fhktr35p"
  }, {
    name: "Disney FAMA",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_10.png?v=97lzwomz8jc"
  }, {
    name: "Walmart Audit",
    logo: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/partner_logo_4.png?v=di5k130u5k8"
  }, {
    name: "Target Compliance",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/partner_target.png"
  }, {
    name: "Canadian Safety",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/cert_canada.png"
  }];
  return <section data-section-id="10127" id="trusted-by-global-brands" className="bg-background text-foreground py-32 md:py-44 px-6 md:px-10 lg:px-16">
      <div className="mx-auto max-w-[1320px]">
        <div ref={introRef} className={`grid grid-cols-1 md:grid-cols-12 mb-20 md:mb-24 transition-all duration-700 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="md:col-start-4 md:col-span-6 text-center">
            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2rem, 4.5vw, 4rem)",
            fontWeight: 600,
            letterSpacing: "-0.02em",
            lineHeight: 1.1
          }}>
              {isZh ? <>
                  國際標準，
                  <em className="italic font-default">值得信賴</em>
                  的合作夥伴。
                </> : <>
                  {"Global standards, "}
                  <em className="italic font-default">trusted</em>
                  {" partnerships."}
                </>}
            </h2>
            <p className="mt-8 font-default text-foreground/70" style={{
            fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
            fontWeight: 400,
            lineHeight: 1.6
          }}>
              {isZh ? "我們與國際檢測實驗室及市場認證機構保持嚴謹合規合作，確保每件產品均符合全球安全與品質基準。" : "We maintain rigorous compliance with international testing labs and market certification bodies to ensure every product meets global safety and quality benchmarks."}
            </p>
          </div>
        </div>

        <div ref={gridRef} className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {partners.map((partner, i) => <div key={partner.name} data-index={i} className={`group relative bg-card border border-border rounded-lg aspect-[16/9] flex items-center justify-center transition-all duration-300 ease-out hover:border-primary ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: gridVisible ? `${i * 60}ms` : "0ms",
          transitionProperty: "opacity, transform, border-color",
          transitionDuration: "700ms"
        }}>
              <img src={partner.logo} data-wvc-srcset={`${partner.logo}-wvc-srcset`} data-wvc-sizes={`${partner.logo}-wvc-sizes`} alt={partner.name} loading="lazy" decoding="async" className="max-w-[60%] max-h-[60%] object-contain opacity-50 grayscale transition-opacity duration-250 ease-out group-hover:opacity-100" />
            </div>)}
        </div>

        <div className="mt-16 md:mt-20 text-center">
          <Link to="#" className="inline-flex items-center gap-2 font-default text-foreground/80 hover:text-primary transition-colors duration-200" style={{
          fontSize: "0.85rem",
          fontWeight: 500,
          letterSpacing: "0.15em",
          textTransform: "uppercase"
        }}>
            <span className="underline decoration-primary decoration-2 underline-offset-8 hover:decoration-primary transition-all duration-150">
              {isZh ? "查詢我們的合規標準" : "Inquire about our compliance standards"}
            </span>
            <ArrowRight className="h-4 w-4 text-primary" />
          </Link>
        </div>
      </div>
    </section>;
}